var $ = jQuery;

function go() {
	if ($("#scrollbar1").length) {
		$('#scrollbar1').tinyscrollbar({
			sizethumb:50
		});
	}
	$(".scrollbarContainer").tinyscrollbar();
}

module.exports = go;